"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
/**Obtiene la cantidad de columnas originales */
function getOriginalColumnCount(totalColumns, drillDownCount) {
    return totalColumns - drillDownCount;
}
exports.getOriginalColumnCount = getOriginalColumnCount;
/**Obtiene todas las columnas efectivas del grid, que son las originales concatenadas con las de drill down*/
function getEffectiveColumns(originalColumns, drillDowns) {
    const drillDownColumns = keautils_1.mapObject(drillDowns, x => drillDownToColumn(originalColumns, x));
    return Object.assign({}, originalColumns, drillDownColumns);
}
exports.getEffectiveColumns = getEffectiveColumns;
/**Devuelve el nuevo state de un grid despues de una operación de quitar columna */
function quitarColumna(key, oldValue) {
    const newValue = Object.assign({}, oldValue, { drillDowns: keautils_1.filterObject(oldValue.drillDowns, (value, dkey) => dkey != key), mapping: oldValue.mapping.filter(x => x != key) });
    return newValue;
}
exports.quitarColumna = quitarColumna;
/**Devuelve el nuevo state despues de agregar un drilldown
 * @param column indice de la columna original
 * @param path ruta del drilldown
 */
function addDrilldown(column, path, oldValue) {
    const last = oldValue.drillDowns;
    const lastDrillDownCol = last[column];
    const originalPath = (lastDrillDownCol && lastDrillDownCol.path) || [];
    const originalColumn = lastDrillDownCol == null ? column : lastDrillDownCol.columna;
    const realPath = [...originalPath, ...path];
    const newValue = { columna: originalColumn, path: realPath };
    const newKey = getDrillDownKey(newValue.columna, newValue.path);
    //Nuevos valores
    //Si el drill down ya existe no hay problema ya que simplemente se sustituira por otro drilldown equivalente
    const drillDowns = Object.assign({}, last, { [newKey]: newValue });
    const mapping = [...oldValue.mapping, newKey];
    return Object.assign({}, oldValue, { drillDowns, mapping });
}
exports.addDrilldown = addDrilldown;
/**Convierte un drill down a una columna del grid */
function drillDownToColumn(originalColumns, drillDown) {
    const column = originalColumns[drillDown.columna];
    const title = getDrillDownTitle(column.title, drillDown.path);
    const cell = (row) => ({
        data: getPathData(column.cell(row).data, drillDown.path)
    });
    return {
        title,
        cell: cell,
        key: getDrillDownKey(drillDown.columna, drillDown.path)
    };
}
function getDrillDownKey(column, path) {
    return "_drilldown:" + column + ":" + path.join("/");
}
function getDrillDownTitle(colTitle, path) {
    return colTitle + "/" + (path.length <= 2 ? path.join("/") :
        (".../" + path.slice(2).join("/")));
}
function getPathData(data, path) {
    return path.reduce((data, prop) => data && data[prop], data);
}
/**Devuelve true si una llave de mapeo es de una columna de drilldown */
function isDrilldownColumn(key) {
    return ("" + key).startsWith("_drilldown:");
}
exports.isDrilldownColumn = isDrilldownColumn;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/simpleGrid/drillDowns.js
// module id = 299
// module chunks = 0